import FooterBackground from "Utils/Assets/Images/footerBackground.png";
import FooterBackgroundForMobile from "Utils/Assets/Images/FooterMob.png";
import TwitterIcon from "Utils/Assets/Icons/TwitterIcon";
import DiscordIcon from "Utils/Assets/Icons/DiscordIcon";
import TelegramIcon from "Utils/Assets/Icons/TelegramIcon";

import { getProperImageUrl } from "Utils/Helpers";

export const config = {
  footerLogo: getProperImageUrl("4/footerlogo.svg"),
  text: "MeetusVR is a dynamic technology-focused company headquartered in the United Arab Emirates (UAE). Situated in a thriving technological ecosystem, the UAE provides MeetusVR with a wealth of resources and opportunities for growth.",
  footerBackground: FooterBackground,
  footerBackgroundForMobile: FooterBackgroundForMobile,
  menus: [
    {
      id: 1,
      title: "Company",
      linkType: "internal",
      menuLinks: [
        [
          {
            id: 1,
            text: "Home",
            path: "/",
          },
          {
            id: 2,
            text: "About",
            path: "/about",
          },
          {
            id: 3,
            text: "Event",
            path: "/feature-event",
          },
        ],
      ],
    },
    {
        id: 2,
        title: "Coin",
        menuLinks: [
            [
                {
                    id: 1,
                    text: "MVR Wealth Coin",
                    path: "/coin",
                },
                {
                    id: 2,
                    text: "MVR Influence Coin",
                    path: "/coin-two",
                },
                {
                    id: 3,
                    text: "MVR Core Coin",
                    path: "/coin-three",
                },
            ],
        ],
        linkType: "internal",
    },
    {
      id: 3,
      title: "Follow Us",
      menuLinks: [
        [
          {
            id: 1,
            text: "Discord",
            path: "/",
            Icon: DiscordIcon,
          },
          {
            id: 2,
            text: "Telegram",
            path: "/",
            Icon: TelegramIcon,
          },
          {
            id: 3,
            text: "Twitter",
            path: "/",
            Icon: TwitterIcon,
          },
        ],
      ],
      linkType: "external",
      socialMediaLinks: true,
    },
  ],
  subFooter: {
    text: `Copyright © MeetUsVR ${new Date()?.getFullYear()} All Right Reserved`,
    links: [
      {
        id: 1,
        text: "Privacy Policy",
        path: "/privacy-policy",
      },
      {
        id: 2,
        text: "Terms of Service",
        path: "/terms-of-services",
      },
      {
        id: 3,
        text: "API Terms of Service",
        path: "/api-terms-of-services",
      },
    ],
  },
};
